import service from '@/store/services/dashboard-service';

const state = {
    list: {},
    item: {},
    display: {},
    selected: {},
    meta: {},
    url: null,
    vendorStats: null,
    departmentStats: null,
    portStats: null,
    adminStats: null,
    todayStats: null,
    activityLogs: [],
    isLoading: false,
    error: null
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, item) => {
        state.display = item;
    },
    SET_SELECTED: (state, item) => {
        state.selected = item;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    },
    SET_URL: (state, url) => {
        state.url = url;
    },
    SET_VENDOR_STATS: function(state, data) {
        state.vendorStats = data;
    },
    SET_DEPARTMENT_STATS: function(state, data) {
        state.departmentStats = data;
    },
    SET_PORT_STATS: function(state, data) {
        state.portStats = data;
    },
    SET_ADMIN_STATS: function(state, data) {
        state.adminStats = data;
    },
    SET_TODAY_STATS: function(state, data) {
        state.todayStats = data;
    },
    SET_ACTIVITY_LOGS: function(state, data) {
        state.activityLogs = data;
    },
    SET_LOADING: function(state, status) {
        state.isLoading = status;
    },
    SET_ERROR: function(state, error) {
        state.error = error;
    }
};

const actions = {
    list ({ commit, dispatch }, params) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    selected ({ commit, dispatch }, params) {
        { commit('SET_SELECTED', params); }
    },

    display ({ commit },params) {
        return service.display(params)
            .then((item) => {
                commit('SET_RESOURCE', item);
            });
    },

    add ({ commit, dispatch }, params) {
        return service.add(params)
            .then((item) => {
                commit('SET_RESOURCE', item);
            });
    },

    update ({ commit, dispatch }, params) {
        return service.update(params)
            .then((item) => {
                commit('SET_RESOURCE', item);
            });
    },

    destroy ({ commit, dispatch }, params) {
        return service.destroy(params);
    },

    upload ({ commit, dispatch }, { item, image }) {
        return service.upload(item, image)
            .then((url) => {
                commit('SET_URL', url);
            });
    },
    fetchVendorStats: function({ commit }, params) {
        commit('SET_LOADING', true);
        return service.getVendorStats(params)
            .then(function(data) {
                commit('SET_VENDOR_STATS', data);
                commit('SET_ERROR', null);
                commit('SET_LOADING', false);
                return data;
            })
            .catch(function(error) {
                var errorMessage = error.response && error.response.data ? error.response.data.message : 'Failed to fetch vendor stats';
                commit('SET_ERROR', errorMessage);
                commit('SET_LOADING', false);
                throw error;
            });
    },

    fetchDepartmentStats: function({ commit }, params) {
        commit('SET_LOADING', true);
        return service.getDepartmentStats(params)
            .then(function(data) {
                commit('SET_DEPARTMENT_STATS', data);
                commit('SET_ERROR', null);
                commit('SET_LOADING', false);
                return data;
            })
            .catch(function(error) {
                var errorMessage = error.response && error.response.data ? error.response.data.message : 'Failed to fetch department stats';
                commit('SET_ERROR', errorMessage);
                commit('SET_LOADING', false);
                throw error;
            });
    },

    fetchPortStats: function({ commit }, params) {
        commit('SET_LOADING', true);
        return service.getPortStats(params)
            .then(function(data) {
                commit('SET_PORT_STATS', data);
                commit('SET_ERROR', null);
                commit('SET_LOADING', false);
                return data;
            })
            .catch(function(error) {
                var errorMessage = error.response && error.response.data ? error.response.data.message : 'Failed to fetch port stats';
                commit('SET_ERROR', errorMessage);
                commit('SET_LOADING', false);
                throw error;
            });
    },

    fetchAdminStats: function({ commit }, params) {
        commit('SET_LOADING', true);
        return service.getAdminStats(params)
            .then(function(data) {
                commit('SET_ADMIN_STATS', data);
                commit('SET_ERROR', null);
                commit('SET_LOADING', false);
                return data;
            })
            .catch(function(error) {
                var errorMessage = error.response && error.response.data ? error.response.data.message : 'Failed to fetch admin stats';
                commit('SET_ERROR', errorMessage);
                commit('SET_LOADING', false);
                throw error;
            });
    },

    fetchTodayStats: function({ commit }, params) {
        commit('SET_LOADING', true);
        return service.getTodayStats(params)
            .then(function(data) {
                commit('SET_TODAY_STATS', data);
                commit('SET_ERROR', null);
                commit('SET_LOADING', false);
                return data;
            })
            .catch(function(error) {
                var errorMessage = error.response && error.response.data ? error.response.data.message : 'Failed to fetch today stats';
                commit('SET_ERROR', errorMessage);
                commit('SET_LOADING', false);
                throw error;
            });
    },

    fetchActivityLogs: function({ commit }, params) {
        commit('SET_LOADING', true);
        return service.getActivityLogs(params)
            .then(function(data) {
                commit('SET_ACTIVITY_LOGS', data);
                commit('SET_ERROR', null);
                commit('SET_LOADING', false);
                return data;
            })
            .catch(function(error) {
                var errorMessage = error.response && error.response.data ? error.response.data.message : 'Failed to fetch activity logs';
                commit('SET_ERROR', errorMessage);
                commit('SET_LOADING', false);
                throw error;
            });
    },

    resolveAlert: function({ commit }, alertId) {
        commit('SET_LOADING', true);
        return service.resolveAlert(alertId)
            .then(function(response) {
                commit('SET_ERROR', null);
                commit('SET_LOADING', false);
                return response;
            })
            .catch(function(error) {
                var errorMessage = error.response && error.response.data ? error.response.data.message : 'Failed to resolve alert';
                commit('SET_ERROR', errorMessage);
                commit('SET_LOADING', false);
                throw error;
            });
    },

    exportDashboardReport: function({ commit }, params) {
        commit('SET_LOADING', true);
        return service.exportReport(params)
            .then(function(blob) {
                commit('SET_LOADING', false);
                return blob;
            })
            .catch(function(error) {
                var errorMessage = error.response && error.response.data ? error.response.data.message : 'Failed to export report';
                commit('SET_ERROR', errorMessage);
                commit('SET_LOADING', false);
                throw error;
            });
    },

    clearError: function({ commit }) {
        commit('SET_ERROR', null);
    }
};

const getters = {
    list: state => state.list,
    display: state => state.display,
    selected: state => state.selected,
    listTotal: state => state.meta.page.total,
    dashboard: state => state.item,
    url: state => state.url,
    vendorStats: function(state) {
        return state.vendorStats;
    },
    departmentStats: function(state) {
        return state.departmentStats;
    },
    portStats: function(state) {
        return state.portStats;
    },
    adminStats: function(state) {
        return state.adminStats;
    },
    todayStats: function(state) {
        return state.todayStats;
    },
    activityLogs: function(state) {
        return state.activityLogs;
    },
    isLoading: function(state) {
        return state.isLoading;
    },
    error: function(state) {
        return state.error;
    }
};

const display = {
    namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
};

export default display;
